module.exports = __webpack_public_path__ + "img/course106_curriculum.9679c073.png";